// extracted by mini-css-extract-plugin
export default {"Separator":"Separator_Separator__YWZmY"};